// Module
var code = "<div class=\"aliplayer-danmuku abp\" style=\"z-index: 999;position: absolute\">\n    <div class=\"danmu container\"></div>\n</div>";
// Exports
module.exports = code;